/* eslint-disable */

import type { BankLang } from "./types/BankLang";

let data: BankLang | undefined;

export type { BankLang };

export default function BankLangFactory(): BankLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setBankLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/BankLangDef").then(({ BankLangDef }) => {
      data = BankLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/BankLangDef").then(({ BankLangDef }) => {
      data = BankLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/BankLangDef").then(({ BankLangDef }) => {
      data = BankLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/BankLangDef").then(({ BankLangDef }) => {
      data = BankLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

